import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-formpadre',
  templateUrl: './formpadre.component.html',
  styleUrls: ['./formpadre.component.scss']
})
export class FormpadreComponent implements OnInit {
    dynamicForm: FormGroup;

    constructor(@Inject(MAT_DIALOG_DATA) public data: {data_sel: any},
                public dialogRef: MatDialogRef<FormpadreComponent>,
                private fb: FormBuilder,) {

        this.dynamicForm = this.fb.group({
            nombre: new FormControl('', [Validators.required])

        });
    }

  ngOnInit(): void {

  }
    private convertValid(obj) {
        //todo: para obetner desde la bdd
        return [];
    }
  Guardar(){
    this.dialogRef.close(this.dynamicForm.controls)
  }
}
